/** Fixture prefixes, not manufacturer TAC allocations. Research supplies no verified
 * PB-model TAC; the 8810 family mirrors supplied tag provisioning identifiers only. */
const PREFIX: Record<string, string> = { PB713: '88107130', 'PB708-PRO': '88107080', PB705: '88107050', PB703: '88107030' };
export function demoImei(model: string, workspace: number, index: number) {
  const serial = ((workspace * 100 + index + 1) * 485863 + 173291) % 1_000_000;
  const body = `${PREFIX[model]}${String(serial).padStart(6, '0')}`;
  const sum = [...body].reduce((total, n, i) => { const v = Number(n) * (i % 2 ? 2 : 1); return total + (v > 9 ? v - 9 : v); }, 0);
  return `${body}${(10 - sum % 10) % 10}`;
}
/** VIN-format fixtures with a check digit; never imply a real registered vehicle. */
export function demoVin(index: number) {
  const body = `${['1HGCV1F30', '5YJ3E1EA0', 'JM3KFBDM0', '1FMCU9G60'][index % 4]}R${['A','F','M'][index % 3]}${String(104417 + index).padStart(6, '0')}`;
  const alphabet = 'ABCDEFGHJKLMNPRSTUVWXYZ', values = [1,2,3,4,5,6,7,8,1,2,3,4,5,7,9,2,3,4,5,6,7,8,9];
  const weights = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
  const sum = [...body].reduce((n, c, i) => n + (/[0-9]/.test(c) ? +c : values[alphabet.indexOf(c)]) * weights[i], 0) % 11;
  return body.slice(0,8) + (sum === 10 ? 'X' : sum) + body.slice(9);
}
